/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CreateSessionRequest {
  scope: 'job_stage';
  job_id?: string | null;
  stage_id?: string | null;
}
